import "./styles/Skeleton.scss";

export const PlayerPlaceholder = () => <div className="PlayerPlaceholder" />;
export const GifBlockPlaceholder = () => <div className="tile GifBlockPlaceholder" />;
export const NicheBlockPlaceholder = () => <div className="nichePreview NicheBlockPlaceholder" />;
